import React from 'react';
// import QMASLogo from 'assets/images/logos/QMAS-logo-white.svg';
import QMASLogoColoured from 'assets/images/logos/QMAS-logo-colour.svg';
import styled from '@emotion/styled';
const StyledImage = styled.img`
  width: 90px;
  height: 90x;
`;
const AppLogo = (props: { src?: any }) => {
  const { src } = props;
  return (
    <StyledImage src={src || QMASLogoColoured} alt="app-logo"></StyledImage>
  );
};

export default AppLogo;
